/**
 * Prepínač vzhľadu kariet. Nie je to dekorácia: pri slabšom skene je text na
 * obrázku nečitateľný a hráč potrebuje vedieť prepnúť na ostrý text bez toho,
 * aby hľadal v nastaveniach. Voľba platí všade, kde sa karta kreslí.
 */

import { useCardDisplay, VARIANT_LABEL, type CardVariant } from './cardDisplay.js';

const ORDER: CardVariant[] = ['art', 'hybrid', 'tooltip', 'template'];

export function CardStyleToggle() {
  const { variant, setVariant } = useCardDisplay();

  return (
    <div className="segment segment--cards" role="group" aria-label="Vzhľad kariet">
      {ORDER.map((option) => (
        <button
          key={option}
          type="button"
          className={`segment__item ${variant === option ? 'is-active' : ''}`}
          onClick={() => setVariant(option)}
        >
          {VARIANT_LABEL[option]}
        </button>
      ))}
    </div>
  );
}
